// extracted by mini-css-extract-plugin
export default {"container":"FormPageLayout_container__uzeQV","formContainer":"FormPageLayout_formContainer__EWuaW","widthHalfPage":"FormPageLayout_widthHalfPage__5qlWB"};